module.exports = __webpack_public_path__ + "static/media/software-9.323525b5.jpg";